import PopupsManager from 'react-sdk/PopupsManager';
import AppState, { POPUPS } from '../../../js/AppState';
import classes from './UserWidget.module.css';

import Texts from 'react-sdk/Texts';
import Button from '../Button/Button';




const UserWidget = ({userEmail, onDisconnect, textColor = "var(--astek-green)"}) => {
  function handleLogout(e) {
    e.preventDefault()
    AppState.logout().then(() => {
      onDisconnect?.()
    })
  }

  return (
    <div className={classes.UserWidget} style={{"--text-color" : textColor}}>
      <div className={classes.email}>
        {userEmail}
      </div>
      <div className={classes.btn} onClick={handleLogout}>{Texts.get("user-disconnect-btn")}</div>
    </div>
  );
};

export default UserWidget;
